<app-dc-pane [loading]="loading" [tableContainer]="true" [noHeader]="true">
  <app-dc-table
    [rows]="filteredRows"
    [columns]="columns"
    [messages]="messages"
    [sort]="sort"
    (activate)="tableActivate($event)"
    [selectedRow]="true"
    [selected]="selected"
    (select)="onSelect($event)"
    [scrollV]="true"
    *ngIf="!loading"
  ></app-dc-table>
  <a
    class="newPayload btn btn-link"
    [routerLink]="['/validation/post']"
    title="Validate New Payload"
    >New Payload</a
  >
</app-dc-pane>
